/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { setLang } from './redux/actions';

import { I18n } from '@aws-amplify/core';

/*
 * Load Branded Theme
 */
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './branding'

/*
 * Load LandingPage for SingIn/SingUp
 */
import LandingPage from './components/LandingPage/LandingPage';

/*
 * Load i18n Localization
 */
import i18nStrings from './i18n/i18n';
I18n.putVocabularies(i18nStrings);

/*
 *  Load Default Language
 * Always use Japanese as default
 */
const loadDefaultLanguage = () => {
	return "ja"
}

/*
 * Map lang state to p
 */
const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	}
}

class App extends React.Component {
	constructor(props) {
		super(props);

		this.props.setLang(loadDefaultLanguage());

		this.state = {};
	}

	render() {
		// `/` では client_id が必須。クエリにも localStorage にも無ければエラー画面へ。
		// 他ルート（/dashboard, /settings 等）は現状通り任意。
		const qs = new URLSearchParams(window.location.search);
		const clientId = qs.get('client_id') || localStorage.getItem('client-id');
		if (!clientId) {
			return <Redirect to="/error?reason=missing_client_id" />;
		}

		return (
			<div>
				<MuiThemeProvider theme={theme}>
					<LandingPage />
				</MuiThemeProvider>
			</div>
		);
	}
}

export default connect(mapStateToProps, { setLang })(App);
